module.exports = "<div *ngIf=\"subProduct\" class=\"subproduct-item\" (click)=\"onSelected($event, subProduct, product, productGroup)\">\r\n    <div class=\"product-spinner\" [class.hide]=\"!isLoadingShow\">\r\n        <img src=\"assets/img/25.gif\" />\r\n    </div>\r\n\r\n    <div class=\"subproduct-image\" [class.selected]=\"subProduct.isSelected\"><img class=\"subproduct-img\" style=\"opacity: 0\" src=\"\" /></div>\r\n    <div class=\"subproduct-title\">{{subProduct.title.getValue()}}</div>\r\n    <div class=\"subproduct-subtitle\">{{subProduct.subtitle.getValue()}}</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/sidebar/subproduct.component.html
// module id = 563
// module chunks = 1